import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Actions from '../../base/Actions/Actions.js';
import { IActionsProps } from '../../base/Actions/models/index.js';
import Grid from '../../base/Grid/Grid.js';
import Translate from '../../base/Translate/Translate.js';

import { IFundManagerConfiguration, IFundManagerProps, IFundManagerState } from './models/index.js';
import ActionsWrapper from './styledComponents/ActionsWrapper.js';
import FundManagerImage from './styledComponents/FundManagerImage.js';
import FundManagerPlaceholder from './styledComponents/FundManagerPlaceholder.js';
import ImageWrapper from './styledComponents/ImageWrapper.js';
import Name from './styledComponents/Name.js';
import Title from './styledComponents/Title.js';
import Wrapper from './styledComponents/Wrapper.js';
import { FUND_MANAGER_CATEGORY_KEY, FUND_MANAGER_COMPONENT_KEY } from './FundManager.meta.js';

export class FundManager extends ComponentBase<IFundManagerProps, IFundManagerState, IFundManagerConfiguration> {
	categoryKey = FUND_MANAGER_CATEGORY_KEY;
	componentKey = FUND_MANAGER_COMPONENT_KEY;

	constructor(props: IFundManagerProps) {
		super(props);
	}
	actionsProps: IActionsProps | undefined;
	get orchestratedActionsProps() {
		if (!this.actionsProps) {
			const { actionsProps, value } = this.props;
			if (actionsProps && actionsProps.buttons) {
				actionsProps.buttons.forEach((buttonProps) => {
					buttonProps.payload = value;
				});
				this.actionsProps = actionsProps;
			}
		}
		return this.actionsProps;
	}
	render() {
		const { className, value, gridProps } = this.props;

		if (
			!common.commonUtils.isNullOrUndefined(gridProps) &&
			!common.commonUtils.isNullOrUndefined(value) &&
			!common.commonUtils.isNullOrUndefined(value.queryStore)
		) {
			return <Grid {...gridProps} queryStore={value.queryStore} />;
		}

		if (!common.commonUtils.isNullOrUndefined(value)) {
			const { photoSrc, name, title } = value;
			const actionsProps = this.orchestratedActionsProps;

			return (
				<Wrapper className={className}>
					{photoSrc && (
						<ImageWrapper>
							<FundManagerImage src={photoSrc} />
							<FundManagerPlaceholder asset={'management.fundManager.placeholder'} />
						</ImageWrapper>
					)}
					<Name>{name}</Name>
					{title && (
						<Title>
							<Translate>{title}</Translate>
						</Title>
					)}
					{actionsProps && (
						<ActionsWrapper>
							<Actions {...actionsProps} />
						</ActionsWrapper>
					)}
				</Wrapper>
			);
		}

		return null;
	}
}

export default InjectedStyledComponent(observer(FundManager), FUND_MANAGER_CATEGORY_KEY, FUND_MANAGER_COMPONENT_KEY);
